import { setter } from './utils';
import { SET_TOOLBAR_BUTTON_LIST_WIDTH } from '../actions/types';

export default setter(SET_TOOLBAR_BUTTON_LIST_WIDTH, 0);
